const InfoCommon = require('od-modules/helpers/map/info/info_common');
const {getCornerPosition} = require('od-modules/helpers/map/orientation');
const INFO_WINDOW_OPTIONS = {
    offset: {
        posX: 5,
        posY: 5,
    },
    maxWidth: 0,
    boxClass: 'odf-grid-col odf-col-span4 odf-col-nogutter',
    enableEventPropagation: true,
    pane: 'floatPane',
    closeBoxURL: '',
};

function getOffsetToCenterBox() {
    return Odigeo._.values({
        horizontal: -($(this.infoWindow.div_).outerWidth() / 2),
        vertical: -37, // .od-custom-marker-pin height
    });
}

function toggleMapControls(hasControl) {
    this.map.setOptions({
        mapTypeControl: hasControl,
        streetViewControl: hasControl,
        disableDoubleClickZoom: !hasControl,
    });
    this.map.setClickableIcons(hasControl);
}

function clearInfoBoxEvents() {
    this.libMap.event.removeListener(this.infoWindow.mapListener_);
}

function bindInfoBoxEvents(options) {
    this.libMap.event.addListener(this.map, 'center_changed', Odigeo._.bind(this.setFixedCornerPosition, this));
    this.libMap.event.addListener(this.infoWindow, 'closeWindow', Odigeo._.bind(toggleMapControls, this, true));
    this.libMap.event.addListener(
        this.infoWindow,
        'domready',
        options.removeHotelInfoMapListener ? Odigeo._.bind(clearInfoBoxEvents, this) : Odigeo._.noop
    );
}

function InfoBox(map, libMap, options) {
    InfoCommon.call(this, map, libMap, options);
    this.infoWindow = new this.libMap.InfoBox();
    this.setCommonOptions(options.infoWindowOptions || {});
    this.bindCommonEvents();
    bindInfoBoxEvents.call(this, options);
}

InfoBox.prototype = Object.create(InfoCommon.prototype);
InfoBox.prototype.constructor = InfoBox;

InfoBox.prototype.getDiv = function() {
    return this.infoWindow.div_;
};

InfoBox.prototype.refresh = function() {
    toggleMapControls.call(this, false);
    this.setFixedCornerPosition(this);
    this.libMap.event.trigger(this, 'refresh');
};

InfoBox.prototype.getDefaultOptions = function(options) {
    const offset = Odigeo._.get(options, 'offset', INFO_WINDOW_OPTIONS.offset);

    return Odigeo._.extend({}, INFO_WINDOW_OPTIONS, {
        pixelOffset: new this.libMap.Size(offset.posX, offset.posY),
    }, options);
};

InfoBox.prototype.centerMapPosition = function() {
    this.map.setCenter(this.getSelectedMarker().getPosition());
    this.map.panBy.apply(this.map, getOffsetToCenterBox.call(this));
};

InfoBox.prototype.setFixedCornerPosition = function() {
    this.infoWindow.setPosition(getCornerPosition(this.libMap, this.map).topLeft);
};

module.exports = InfoBox;
